/**
 * Rutas de Firestore en un solo sitio. Escribirlas a mano en cada consulta es
 * como acaban las reglas de seguridad protegiendo una coleccion que el codigo
 * ya no usa.
 */

export const COLLECTIONS = {
  users: 'users',
  orgs: 'orgs',
  slugs: 'slugs',
  qrcodes: 'qrcodes',
  scans: 'scans',
  stats: 'stats',
  invites: 'invites',
  auditLogs: 'auditLogs',
} as const;

export const paths = {
  user: (uid: string) => `${COLLECTIONS.users}/${uid}`,

  org: (orgId: string) => `${COLLECTIONS.orgs}/${orgId}`,
  members: (orgId: string) => `${COLLECTIONS.orgs}/${orgId}/members`,
  member: (orgId: string, uid: string) => `${COLLECTIONS.orgs}/${orgId}/members/${uid}`,
  usage: (orgId: string) => `${COLLECTIONS.orgs}/${orgId}/usage`,
  usageMonth: (orgId: string, month: string) =>
    `${COLLECTIONS.orgs}/${orgId}/usage/${month}`,

  /** El id del documento es el propio slug: unicidad garantizada por Firestore. */
  slug: (slug: string) => `${COLLECTIONS.slugs}/${slug}`,

  qrcode: (codeId: string) => `${COLLECTIONS.qrcodes}/${codeId}`,
  qrVersions: (codeId: string) => `${COLLECTIONS.qrcodes}/${codeId}/versions`,

  scan: (scanId: string) => `${COLLECTIONS.scans}/${scanId}`,

  dailyStats: (codeId: string) => `${COLLECTIONS.stats}/${codeId}/daily`,
  dailyStatsDay: (codeId: string, day: string) =>
    `${COLLECTIONS.stats}/${codeId}/daily/${day}`,

  invite: (inviteId: string) => `${COLLECTIONS.invites}/${inviteId}`,
} as const;

/** Clave del periodo de consumo: `2026-09`. Siempre en UTC. */
export function usageMonthKey(date: Date = new Date()): string {
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** Clave del agregado diario: `2026-09-14`. Siempre en UTC. */
export function dayKey(date: Date = new Date()): string {
  return date.toISOString().slice(0, 10);
}
